import styled from 'styled-components';
import {Accordion, AccordionSummary, AccordionDetails} from "@material-ui/core"
import { FaMinus, FaPlus } from 'react-icons/fa';
import React from "react"
import SectionWrapper from "../SectionWrapper"
import { queries } from "../../../breakpoints"
import { GHSvgIconMinus } from "../../../../static/images/svgs/GHSvgIconMinus";
import { GHSvgIconPlus } from "../../../../static/images/svgs/GHSvgIconPlus";

export const StyledWrapper = styled(SectionWrapper)`
    .MuiAccordion-root:before{
        display: none;
    }

        .MuiButtonBase-root.MuiAccordionSummary-root{ 
          margin-bottom: -1px;
          border: 1px solid rgba(0,0,0,0);
          transition: border-color .3s;
        }
        .MuiButtonBase-root.MuiAccordionSummary-root:hover{
        
          border: 1px solid #A4A3A3; 
          background: #F9F9F9;
        }

      .Mui-expanded {
        margin: 0 0 !important;
        .MuiButtonBase-root.MuiAccordionSummary-root{
          border-bottom: 1px solid #A4A3A3;
          border-top: none;
          border-left: none;
          border-right: none;
          background: none;
        }
      }

      .MuiAccordionSummary-expandIcon {
        transform: scale(1.4);
      }

      .MuiIconButton-edgeEnd{
        margin-right: 0px;
      }
`;

export const Headline = styled.h3`
  font-family: var(--jetSansDigital-fontFamily);
    font-size: var(--fontSize-5);
    font-weight: bold;
    margin-bottom: 35px;
    @media(${queries.max_break_md}){
        display:none;
    }
`;

export const MobileHeadline = styled(Headline)`
    display:block;
  font-family: var(--jetSansDigital-fontFamily);
  text-align: center;
    @media(${queries.min_break_md}){
        display:none;
    }
`;

export const StyledAccordion = styled(Accordion)`
  font-family: var(--jetSansDigital-fontFamily);
    // Increase specificity with '&&&' to override styles from MUI
    &&& {
        box-shadow: none;
        background-color: transparent;
        
        .MuiCollapse-root:not(.MuiCollapse-hidden){
          padding: 30px 20px;  
        }
        
        .MuiAccordionDetails-root{
            //padding:0
            padding: 0;
        } 
      
    }
    .MuiIconButton-label {
      svg {
        width: 100%;
        max-width: 28px;
      }
    }
`;

export const StyledAccordionHeader = styled.h5`
  font-family: var(--jetSansDigital-fontFamily);
    margin: 0;
    font-weight: bold;
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  font-family: var(--jetSansDigital-fontFamily);
    &&& {
        margin: 0;
        padding: 0
    }
`;

export const StyledChevron = styled(( { expanded } ) => {
    return expanded ? <GHSvgIconMinus/> : <GHSvgIconPlus/>;
})`
    color: #242E30;
`;

/*
{ expanded }) => {

    return expanded ? <FaMinus /> : <FaPlus />;
}

 */

export const Panel = styled(AccordionSummary)`
  font-family: var(--jetSansDigital-fontFamily);
  &&& {

        //padding-left: 0;
        padding: 30px 20px;
    }
`;
